import React from 'react';
import styles from './successor-notification.module.scss';
import AvatarStack from '../AvatarStack/AvatarStack';

export const SuccessorNotification = (props) => {
  const { data } = props;
  if (!data || data.length === 0) return <></>;
  const formattedData = JSON.parse(data);
  if (formattedData && formattedData?.total === 0) return <></>;

  return (
    <>
      <div className={styles.container}>
        <AvatarStack data={formattedData?.avatar || []} total={formattedData?.total || 0} />
        <div style={{ marginTop: '8px' }}>
          {formattedData?.total} talent{formattedData?.total > 1 ?? 's'} from <b>{formattedData?.position}</b> in{' '}
          <b>{formattedData?.buisness_unit}</b> have been dropped from the succession planning.
        </div>
      </div>
    </>
  );
};

export default SuccessorNotification;
